import axios from "axios";
import { API_URL } from "../config/apiConfig";

function authHeaders() {
    const token = localStorage.getItem("token");
    return {
        Authorization: `Bearer ${token}`,
    };
}

export async function getSmartLockSettings(affiliateId) {
    const response = await axios.get(`${API_URL}/smart-lock/settings/${affiliateId}`, {
        headers: authHeaders(),
    });
    return response.data;
}

export async function getSmartLockEvents(affiliateId, options = {}) {
    const response = await axios.get(`${API_URL}/smart-lock/settings/${affiliateId}/events`, {
        headers: authHeaders(),
        params: {
            ...(options.page ? { page: options.page } : {}),
            ...(options.status ? { status: options.status } : {}),
        },
    });
    return response.data;
}

export async function saveSeamApiKey(affiliateId, seamApiKey, workspaceId = "", connectedAccountId = "") {
    const response = await axios.post(
        `${API_URL}/smart-lock/settings/${affiliateId}/key`,
        { seamApiKey, workspaceId, connectedAccountId },
        { headers: authHeaders() }
    );
    return response.data;
}

export async function deleteSeamApiKey(affiliateId) {
    const response = await axios.delete(`${API_URL}/smart-lock/settings/${affiliateId}/key`, {
        headers: authHeaders(),
    });
    return response.data;
}

export async function setSmartLockActivation(affiliateId, isSmartLockEnabled) {
    const response = await axios.patch(
        `${API_URL}/smart-lock/settings/${affiliateId}/activation`,
        { isSmartLockEnabled },
        { headers: authHeaders() }
    );
    return response.data;
}

export async function listSeamDevices(affiliateId) {
    const response = await axios.get(`${API_URL}/smart-lock/settings/${affiliateId}/seam-devices`, {
        headers: authHeaders(),
    });
    return response.data;
}

export async function upsertSmartLockDoor(affiliateId, payload) {
    const response = await axios.post(
        `${API_URL}/smart-lock/settings/${affiliateId}/doors`,
        payload,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function deleteSmartLockDoor(affiliateId, doorId) {
    const response = await axios.delete(`${API_URL}/smart-lock/settings/${affiliateId}/doors/${doorId}`, {
        headers: authHeaders(),
    });
    return response.data;
}

export async function upsertSmartLockPolicy(affiliateId, payload) {
    const response = await axios.post(
        `${API_URL}/smart-lock/settings/${affiliateId}/policies`,
        payload,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function deleteSmartLockPolicy(affiliateId, policyId) {
    const response = await axios.delete(
        `${API_URL}/smart-lock/settings/${affiliateId}/policies/${policyId}`,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function upsertSmartLockOverride(affiliateId, payload) {
    const response = await axios.post(
        `${API_URL}/smart-lock/settings/${affiliateId}/overrides`,
        payload,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function deleteSmartLockOverride(affiliateId, overrideId) {
    const response = await axios.delete(
        `${API_URL}/smart-lock/settings/${affiliateId}/overrides/${overrideId}`,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function upsertSmartLockBlockedUser(affiliateId, payload) {
    const response = await axios.post(
        `${API_URL}/smart-lock/settings/${affiliateId}/blocked-users`,
        payload,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function deleteSmartLockBlockedUser(affiliateId, blockId) {
    const response = await axios.delete(
        `${API_URL}/smart-lock/settings/${affiliateId}/blocked-users/${blockId}`,
        { headers: authHeaders() }
    );
    return response.data;
}

export async function getUnlockContext(affiliateId, options = {}) {
    const response = await axios.get(`${API_URL}/smart-lock/unlock-context`, {
        headers: authHeaders(),
        params: {
            affiliateId,
            ...(options.classId ? { classId: options.classId } : {}),
            ...(options.eligibleOnly ? { eligibleOnly: true } : {}),
        },
    });
    return response.data;
}

export async function unlockDoor({ affiliateId, doorId, classId }) {
    const response = await axios.post(
        `${API_URL}/smart-lock/unlock`,
        { affiliateId, doorId, classId },
        { headers: authHeaders() }
    );
    return response.data;
}
